<script>
    import { push } from "svelte-spa-router";
    import * as store from "../stores/store";
    import { get } from "svelte/store";
    import * as api from "../utiles/api";
    import { Preferences } from "@capacitor/preferences";
    import { onMount } from "svelte";
    import toast from "svelte-french-toast"; // 토스트 라이브러리 추가

    import { fetchProcessInspectionData } from "./processInspection/store.js";
    import { fetchFinalInspectionData } from "./finalInspection/store.js";
    import { fetchFinalNonconformityData } from "./finalNonconformity/store.js";
    import { fetchProcessNonconformityData } from "./processNonconformity/store.js";
    import { fetchShipmentData } from "../stores/store.js";
    import { dbTargets, dbInfo, loadDbTargets, loadDbInfo, switchDbTarget, revertToDefaultDb } from "../stores/dbTarget.js";
    import { resetDbTarget } from "../utiles/axios.util";

    let EMPL_NM = "";
    let LOGIN_ID = "";
    let session_bplc_code = "01";
    let tbt_menu_at = "N"; // 'N': 기본메뉴, 'Y': 경영정보메뉴, 'A': 전체

    async function requestCameraPermission() {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                stream.getTracks().forEach((track) => track.stop());
            } catch (err) {
                console.warn("카메라 권한 거부 또는 카메라 없음:", err);
            }
        }
    }

    onMount(async () => {
        const { value } = await Preferences.get({ key: "retechInfo" });
        if (!value) {
            push("/Login");
            return;
        }

        const userData = JSON.parse(value);
        EMPL_NM = userData.empl_nm;
        LOGIN_ID = userData.login_id;
        session_bplc_code = userData.bplc_code || "01";
        
        // tbt_menu_at 권한 체크 ('N': 기본, 'Y': 경영정보, 'A': 전체)
        const rawTbt = userData.tbt_menu_at;
        if (rawTbt) {
            tbt_menu_at = String(rawTbt).trim().toUpperCase();
        } else if (LOGIN_ID === "admin") {
            tbt_menu_at = "A";
        } else {
            tbt_menu_at = "N";
        }

        // 기본메뉴 열람 권한이 있는 경우에만 기본 데이터 프리로드
        if (tbt_menu_at === "N" || tbt_menu_at === "A") {
            preloadAllData();
        }

        // 메인 화면 진입 시 카메라 권한 체크
        requestCameraPermission();

        // 접속 DB 목록 / 현재 DB(사업장명) 로드
        initDbTarget();
    });

    async function preloadAllData() {
        try {
            // 병렬로 데이터 호출 (성능 최적화)
            Promise.all([
                fetchProcessInspectionData(session_bplc_code, true),
                fetchFinalInspectionData(session_bplc_code, true),
                fetchFinalNonconformityData(session_bplc_code, true),
                fetchProcessNonconformityData(session_bplc_code, true),
                fetchShipmentData(session_bplc_code, true),
            ]);
        } catch (err) {
            console.error("Preloading failed:", err);
        }
    }

    const menuItems = [
        {
            title: "공정검사성적서관리",
            description: "공정 중 결과 기록",
            path: "/ProcessInspection",
            category: "basic",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="13" x2="12" y2="17"></line></svg>`,
            color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        },
        {
            title: "공정부적합조치관리",
            description: "공정 부적합품 처리",
            path: "/ProcessNonconformity",
            category: "basic",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path></svg>`,
            color: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
        },
        {
            title: "최종검사성적서관리",
            description: "출하 전 최종 검사",
            path: "/FinalInspection",
            category: "basic",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><path d="M9 15l2 2 4-4"></path></svg>`,
            color: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
        },
        {
            title: "최종부적합조치관리",
            description: "최종 부적합품 조치",
            path: "/FinalNonconformity",
            category: "basic",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>`,
            color: "linear-gradient(135deg, #ff0844 0%, #ffb199 100%)",
        },
        {
            title: "출하등록관리",
            description: "제품 출하 관리",
            path: "/Shipment",
            category: "basic",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon></svg>`,
            color: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
        },
        {
            title: "공급계획(PSI)",
            description: "주차별 공급 계획 및 PSI 점검",
            path: "/SupplyPlan",
            category: "management",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/><circle cx="8" cy="14" r="1.5"/><circle cx="13" cy="5" r="1.5"/><circle cx="18" cy="9" r="1.5"/></svg>`,
            color: "linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)",
        },
        {
            title: "매출현황",
            description: "기간별·품목별 매출 실적 및 추이 분석",
            path: "/SalesStatus",
            category: "management",
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>`,
            color: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
        },
    ];

    $: visibleMenuItems = menuItems.filter((item) => {
        if (tbt_menu_at === "A") return true; // 전체
        if (tbt_menu_at === "Y") return item.category === "management"; // 경영정보메뉴
        return item.category === "basic"; // 'N' 또는 기본값
    });

    // 메뉴 이동 제어 함수
    function navigateWithToast(item) {
        // 모든 구현된 메뉴로 이동 허용
        push(item.path);
    }

    async function performLogout() {
        if (confirm("로그아웃 하시겠습니까?")) {
            try {
                await api.get(`/account/logout`);
            } catch (err) {
                console.error("logout api error", err);
            }

            try {
                await Preferences.remove({ key: "retechInfo" });
                await Preferences.remove({ key: "retech_jwt_token" });
                await Preferences.remove({ key: "retech_refresh_token" });
                // 다음 로그인은 항상 운영 DB 로 시작
                await resetDbTarget();
            } catch (err) {
                console.error("Preferences clear error", err);
            }

            toast.success("로그아웃 되었습니다.");
            push("/Login");
        }
    }

    let switching = false;

    // 접속 DB 목록 + 현재 DB 정보 로드 (개발 DB 연결 실패 시 운영 DB 로 복구)
    async function initDbTarget() {
        const [, ok] = await Promise.all([loadDbTargets(), loadDbInfo()]);
        if (!ok && get(dbInfo).code === "T") {
            toast.error("테스트 DB에 연결할 수 없어 운영 DB로 되돌립니다.");
            setTimeout(revertToDefaultDb, 1200);
        }
    }

    // 운영/개발 DB 전환 (로그아웃 없이 적용, 화면이 새로고침되어 모든 데이터가 새 DB 기준으로 다시 로드됨)
    async function handleDbSwitch(target) {
        if (switching || target.code === $dbInfo.code) return;
        const label = target.dbName ? `${target.name} (${target.dbName})` : target.name;
        if (!confirm(`${label} 으로 전환하시겠습니까?\n로그아웃 없이 화면이 새로고침됩니다.`)) return;
        switching = true;
        await switchDbTarget(target.code);
    }
</script>

<div class="dashboard-wrapper">
    <header class="dashboard-header">
        <div class="logo-area">
            <h1>
                {$dbInfo.companyName || "리텍(주)"}
                {#if $dbInfo.code === "T"}
                    <span class="env-badge" title={$dbInfo.dbName}>테스트 DB</span>
                {/if}
            </h1>
            <div class="user-info">
                <span class="user-name">{EMPL_NM}</span>
                <span class="user-role">{LOGIN_ID}</span>
            </div>
        </div>

        <div class="header-right">
        {#if $dbTargets.length > 1}
            <div class="db-switch" role="group" aria-label="접속 DB 선택">
                {#each $dbTargets as t}
                    <button
                        type="button"
                        class="db-opt"
                        class:active={$dbInfo.code === t.code}
                        class:test={t.code === "T"}
                        title={t.dbName}
                        disabled={switching}
                        on:click={() => handleDbSwitch(t)}
                    >
                        {t.name}
                    </button>
                {/each}
            </div>
        {/if}

        <button class="logout-btn-premium" on:click={performLogout}>
            <div class="logout-icon-wrapper">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
            </div>
            <span>LOGOUT</span>
        </button>
        </div>
    </header>

    <main class="scroll-container">
        <div class="grid-container">
            {#each visibleMenuItems as item}
                <button
                    class="nav-card"
                    on:click={() => navigateWithToast(item)}
                >
                    <div class="icon-circle" style="background: {item.color};">
                        {@html item.icon}
                    </div>
                    <div class="text-group">
                        <h2>{item.title}</h2>
                        <p>{item.description}</p>
                    </div>
                    <div class="hover-indicator"></div>
                </button>
            {/each}
        </div>
    </main>
</div>

<style>
    :global(body) {
        margin: 0;
        padding: 0;
        background-color: #f1f5f9;
        font-family: "Pretendard", sans-serif;
        overflow: hidden;
    }

    .dashboard-wrapper {
        display: flex;
        flex-direction: column;
        width: 100vw;
        height: 100vh;
        padding: 1.5rem;
        box-sizing: border-box;
    }

    .dashboard-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 80px;
        flex-shrink: 0;
        margin-bottom: 1.5rem;
        padding: 0 1rem;
    }

    .logo-area h1 {
        margin: 0;
        font-size: 1.6rem;
        font-weight: 900;
        color: #1e293b;
        letter-spacing: -1px;
    }

    .user-info {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-top: 0.2rem;
    }

    .user-name {
        font-weight: 700;
        color: #3b82f6;
        font-size: 1rem;
    }

    .user-role {
        font-size: 0.8rem;
        background: #e2e8f0;
        color: #475569;
        padding: 0.1rem 0.5rem;
        border-radius: 4px;
        font-weight: 600;
    }

    .logout-btn-premium {
        display: flex;
        align-items: center;
        gap: 0.8rem;
        background: white;
        border: 2px solid #f1f5f9;
        padding: 0.5rem 1.2rem 0.5rem 0.6rem;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.2s;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    }

    .logout-btn-premium span {
        font-weight: 800;
        font-size: 0.85rem;
        color: #64748b;
        letter-spacing: 0.5px;
    }

    .logout-icon-wrapper {
        background: #fee2e2;
        color: #ef4444;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: all 0.2s;
    }

    .logout-btn-premium:hover {
        border-color: #fecaca;
        transform: translateX(3px);
    }

    .logout-btn-premium:hover .logout-icon-wrapper {
        background: #ef4444;
        color: white;
    }

    .header-right {
        display: flex;
        align-items: center;
        gap: 0.8rem;
    }

    .env-badge {
        display: inline-block;
        vertical-align: middle;
        margin-left: 0.5rem;
        padding: 0.15rem 0.55rem;
        border-radius: 6px;
        background: #f97316;
        color: white;
        font-size: 0.7rem;
        font-weight: 800;
        letter-spacing: 0;
    }

    .db-switch {
        display: inline-flex;
        background: #e2e8f0;
        border-radius: 50px;
        padding: 4px;
        gap: 2px;
    }

    .db-opt {
        border: none;
        background: transparent;
        color: #64748b;
        font-size: 0.82rem;
        font-weight: 800;
        padding: 0.45rem 1rem;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.2s;
        white-space: nowrap;
    }

    .db-opt:hover:not(.active):not(:disabled) {
        background: rgba(255, 255, 255, 0.7);
        color: #1e293b;
    }

    .db-opt.active {
        background: #3b82f6;
        color: white;
        box-shadow: 0 2px 6px rgba(59, 130, 246, 0.35);
        cursor: default;
    }

    .db-opt.active.test {
        background: #f97316;
        box-shadow: 0 2px 6px rgba(249, 115, 22, 0.4);
    }

    .db-opt:disabled {
        opacity: 0.6;
    }

    .scroll-container {
        flex: 1;
        overflow-y: auto;
        padding-right: 0.5rem;
    }

    .scroll-container::-webkit-scrollbar {
        width: 6px;
    }
    .scroll-container::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 10px;
    }

    .grid-container {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 1.5rem;
        max-width: 1200px;
        margin: 0 auto;
        padding: 0.5rem;
    }

    .nav-card {
        background: white;
        border: none;
        border-radius: 1.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 240px;
        padding: 2rem;
        cursor: pointer;
        position: relative;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.03);
    }

    .nav-card:hover {
        transform: translateY(-8px);
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
        border-color: #3b82f6;
    }

    .icon-circle {
        width: 5.5rem;
        height: 5.5rem;
        border-radius: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        margin-bottom: 1.5rem;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2);
    }

    .icon-circle :global(svg) {
        width: 2.8rem;
        height: 2.8rem;
    }

    .text-group h2 {
        margin: 0;
        font-size: 1.4rem;
        font-weight: 800;
        color: #0f172a;
        margin-bottom: 0.6rem;
    }

    .text-group p {
        margin: 0;
        font-size: 1rem;
        color: #64748b;
        font-weight: 500;
    }

    .hover-indicator {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 5px;
        background: #3b82f6;
        transition: width 0.3s ease;
        border-radius: 5px 5px 0 0;
    }

    .nav-card:hover .hover-indicator {
        width: 40%;
    }

    @media (max-width: 640px) {
        .grid-container {
            grid-template-columns: 1fr;
        }
        .dashboard-header {
            height: auto;
            flex-direction: column;
            gap: 1rem;
            align-items: flex-start;
        }
        .header-right {
            align-self: flex-end;
        }
    }
</style>
